import { gql } from '@apollo/client'

export type {
  UnassignedClients,
  UnassignedClients_unassignedClients_UnassignedClients_clients_UnassignedClient as UnassignedClient,
} from './types/index.graphql'

export const UNASSIGNED_CLIENTS = gql`
  query UnassignedClients {
    unassignedClients {
      clients {
        id
        name
        brand
        governmentId
        daysSinceVisit
      }
    }
  }
`
